export const WARDS = [
  "Balsall & Berkswell",
  "Blythe",
  "Castle Bromwich",
  "Chelmsley Wood",
  "Dorridge & Hockley Heath",
  "Elmdon",
  "Fordbridge",
  "Kingshurst & Smith\u2019s Wood",
  "Knowle",
  "Lyndon",
  "Meriden & Arden",
  "Olton",
  "Shirley East & Sharmans Cross",
  "Shirley South",
  "Shirley West",
  "Silhill",
  "St Alphege with Monkspath & Hillfield",
];

export const PRIORITIES = [
  { id: "crime", label: "Crime & Policing", icon: "ShieldAlert", desc: "Tackling anti-social behaviour and visible policing" },
  { id: "roads", label: "Potholes & Roads", icon: "TrafficCone", desc: "Road repairs, potholes and pavements" },
  { id: "council_tax", label: "Council Tax", icon: "PoundSterling", desc: "Value for money and lower bills" },
  { id: "bins", label: "Waste & Bin Collections", icon: "Trash2", desc: "Reliable collections and fly-tipping" },
  { id: "immigration", label: "Immigration & Local Impact", icon: "Users", desc: "Pressure on local services and housing" },
  { id: "nhs", label: "NHS & GP Access", icon: "HeartPulse", desc: "Getting a GP and dentist appointment" },
  { id: "greenbelt", label: "Green Belt Protection", icon: "Trees", desc: "Protecting green spaces from overdevelopment" },
  { id: "transport", label: "Public Transport", icon: "Bus", desc: "Reliable buses and connectivity" },
  { id: "highstreet", label: "Local High Streets", icon: "Store", desc: "Supporting town centres and small business" },
  { id: "housing", label: "Housing & Development", icon: "Home", desc: "Sensible, well-planned housing" },
];

export const ISSUE_CATEGORIES = [
  "Potholes / Road damage",
  "Fly-tipping / Litter",
  "Anti-social behaviour",
  "Street lighting",
  "Overgrown verges / trees",
  "Missed bin collection",
  "Parking problems",
  "Damaged pavements",
  "Other",
];

export const COUNCIL_SATISFACTION = [
  "Very satisfied",
  "Satisfied",
  "Neutral",
  "Dissatisfied",
  "Very dissatisfied",
];

export const DIRECTION_OPTIONS = [
  "Yes, the right direction",
  "No, the wrong direction",
  "Not sure",
];

export const RESIDENT_YEARS = [
  "Less than 2 years",
  "2 to 10 years",
  "10 to 20 years",
  "More than 20 years",
  "All my life",
];

export const SOLIHULL_IMAGES = {
  aerial: "https://customer-assets-39nsmqrw.emergentagent.net/job_tell-solihull/artifacts/g7sq60vf_solihull%201.webp",
  highstreet: "https://customer-assets-39nsmqrw.emergentagent.net/job_tell-solihull/artifacts/w21pzwp9_solihull%202.jpeg",
  church: "https://customer-assets-39nsmqrw.emergentagent.net/job_tell-solihull/artifacts/qvrhvx7s_solihull%203.webp",
  town: "https://customer-assets-39nsmqrw.emergentagent.net/job_tell-solihull/artifacts/xxom8d7f_solihull%204.webp",
};

export const VOTING_OPTIONS = [
  "Reform UK",
  "Conservative",
  "Labour",
  "Liberal Democrat",
  "Green",
  "Undecided",
  "Prefer not to say",
];
